<template>
    <van-popup
        :value.sync="customerSelectVisible"
        round
        position="bottom"
        :style="{ height: '77%' }"
        @click-overlay="handleClosePopup"
        v-if="customerSelectVisible"
    >
        <div class="user_select_wrap">
            <div class="user_select_wrap_title">
                <van-icon @click="handleClosePopup" name="arrow-left" />
                <span class="title">{{ customerSelectTitle }}</span>
                <span class="confirm_text" @click="handleClickConfirmSelect">确定</span>
            </div>
            <div class="user_select_wrap_search">
                <van-search v-model="searchForm.keyword" placeholder="请输入" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="user_select_content">
                <div class="user_select_content_scroll">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="item in customerList" :key="item.id" @click="handleClickItem(item)">
                            <div>
                                <span>{{ item.name}}</span>
                            </div>
                            <van-icon
                                name="success"
                                color="#2990F0"
                                v-if="
                                    ((selectType == 'multiple' && selectCustomerList.find((find) => find.id == item.id)) || (selectType == 'one' && selectCustomerData.id === item.id))
                                        ? true
                                        : false
                                "
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { customerListByPinYin , GetCustomerPrivateList} from "@/api";
import { pagination } from "@/mixins";
export default {
    name: "UserSearchSelect",
    props: {
        customerSelectTitle: {
            type: String,
            default: "",
        },
        customerSelectVisible: {
            type: Boolean,
            default: false,
        },
        extraSearchForm: {
            type: Object,
            default: () => {},
        }, // 查询的时候携带的其它参数
        selectType: {
            type: String,
            default: "one", //单选还是多选 one 单选 multiple 多选
        },
        selectedCustomer: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            customerList: [],
            indexList: [],
            selectCustomerData: {},
            selectCustomerList: [],
            oneLoading: true,
        };
    },
    mixins: [pagination],
    created() {
        this.selectCustomerData = {};
        this.selectCustomerList = [];
        this.getTableData();
    },
    methods: {
        handleClosePopup() {
            this.$emit("update:customerSelectVisible", false);
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.customerList = [];
            this.getTableData();
        },
        onSelect(event) {
            console.log(event);
        },
        handleClickItem(item) {
            if (this.selectType == "one") {
                this.selectCustomerData = item;
                // this.handleClickConfirmSelect();
            } else {
                let index = this.selectCustomerList.findIndex((find) => find.id == item.id);
                if (index > -1) {
                    this.selectCustomerList.splice(index, 1);
                } else {
                    this.selectCustomerList.push(item);
                }
            }
        },
        handleClickConfirmSelect() {
            if (this.selectType == "one") {
                if (!this.selectCustomerData || !this.selectCustomerData.id) return this.$toast("请选择");
                this.$emit("selectCustomerData", this.selectCustomerData);
            } else {
                if (!this.selectCustomerList || this.selectCustomerList.length == 0) return this.$toast("请选择");
                this.$emit("selectCustomerData", this.selectCustomerList);
            }
            this.handleClosePopup();
        },
        onLoadList() {
            if (this.pagination.total == this.customerList.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            const params = {
                keyword: this.searchForm.keyword,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            customerListByPinYin(params).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.customerList = this.customerList.concat(list);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                } else {
                    this.loading = false;
                }
                if (this.oneLoading == true) {
                    this.oneLoading = false;
                    this.oneLoadingFunction();
                }
            });
        },
        oneLoadingFunction() {
            if (this.selectType == "multiple") {
                this.selectCustomerList = [];
                this.customerList.forEach((item, key) => {
                    if (this.selectedCustomer.find((find) => find == list.id)) {
                        this.selectCustomerList.push(list);
                    }
                });
            } else {
                this.customerList.forEach((item, key) => {
                    if (this.selectedCustomer.find((find) => find == list.id)) {
                        this.selectCustomerData = list;
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss">
.user_select_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .user_select_wrap_title {
        flex-shrink: 0;
        padding: 0 16px;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .van-icon-arrow-left {
            font-size: 24px;
            color: rgba(102, 102, 102, 1);
        }
        .title {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
        .confirm_text {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(41, 144, 240, 1);
        }
    }
    .user_select_wrap_search {
        z-index: 1000;
        background: #ffff;
        position: relative;
        .van-search {
            padding: 0 16px;
            .van-search__content {
                border-radius: 6px;
                background: rgba(255, 255, 255, 1);

                border: 1px solid rgba(217, 217, 217, 1);
            }
            .van-icon-search {
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
            }
        }
    }
    .user_select_content {
        flex: 1;
        padding: 10px 0;
        position: relative;
        overflow: hidden;
        .user_select_content_scroll {
            overflow-y: auto;
            width: 100%;
            height: 100%;
        }
        ul {
            padding: 0 16px;
            li {
                padding: 8px 0;
                display: flex;
                align-items: center;
                gap: 12px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
                div {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    flex: 1;
                }
                .avatar_wrap {
                    display: inline-block;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }

                &:active {
                    background-color: rgba(217, 217, 217, 0.2);
                }
            }
        }
    }
    .van-index-bar__sidebar {
        position: absolute;
    }
}
</style>
